export default function SolutionSection() {
  const features = [
    {
      icon: "ri-flashlight-line",
      title: "Real-Time Trigger System",
      desc: "Reach agents within seconds of a new listing — when the deal is still up for grabs.",
    },
    {
      icon: "ri-route-line",
      title: "Smart Opportunity Routing",
      desc: "Turn conversations into closings without manual follow-up.",
    },
    {
      icon: "ri-scales-3-line",
      title: "TCPA + Compliance",
      desc: "Scale outreach safely with built-in compliance — no legal risk slowing you down.",
    },
    {
      icon: "ri-shield-check-line",
      title: "SOC 2 Type II",
      desc: "Enterprise-grade infrastructure trusted by serious title operations.",
    },
    {
      icon: "ri-toggle-line",
      title: "Opt-Out / Consent",
      desc: "Respect contact preferences automatically — no list management required.",
    },
    {
      icon: "ri-lock-password-line",
      title: "Secure Data",
      desc: "Your data — and your clients' — is protected at every step.",
    },
  ];

  return (
    <section className="bg-white py-14 md:py-24 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Left */}
          <div className="lg:sticky lg:top-24">
            <div className="inline-flex items-center gap-2 bg-orange-50 border border-orange-100 rounded-full px-4 py-1.5 mb-6">
              <i className="ri-cpu-line text-primary text-xs" />
              <span className="text-xs font-semibold text-primary">The Imperium Platform</span>
            </div>
            <h2
              className="text-navy font-semibold mb-4"
              style={{ fontSize: "clamp(26px, 3vw, 38px)", lineHeight: "1.2" }}
            >
              The System That Puts You in Every Deal — Before It's Decided
            </h2>
            <p className="text-[#4a5568] text-base mb-8" style={{ lineHeight: "1.65" }}>
              Imperium is purpose-built to get you into the conversations where closings are actually decided — before your competitors are even aware of the opportunity.
            </p>

            {/* Stats */}
            <p className="text-xs font-bold uppercase tracking-widest text-primary mb-4">Proven at scale</p>
            <div className="grid grid-cols-2 gap-4">
              {[
                { value: "1M+", label: "Calls performed" },
                { value: "180k+", label: "Calls per day" },
                { value: "50", label: "Active states" },
                { value: "SOC 2", label: "Type II Certified" },
              ].map((stat) => (
                <div key={stat.label} className="bg-alt-bg rounded-xl p-4">
                  <p className="text-navy text-2xl font-extrabold">{stat.value}</p>
                  <p className="text-[#4a5568] text-xs mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Feature grid */}
          <div className="flex flex-col gap-4">
            {features.map((feat) => (
              <div key={feat.title} className="flex items-start gap-4 p-5 border border-gray-100 rounded-xl hover:border-orange-200 hover:bg-orange-50/30 transition-colors">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-50 rounded-lg flex-shrink-0 mt-0.5">
                  <i className={`${feat.icon} text-primary text-lg`} />
                </div>
                <div>
                  <h3 className="text-navy font-semibold text-sm mb-1">{feat.title}</h3>
                  <p className="text-[#4a5568] text-sm leading-relaxed">{feat.desc}</p>
                </div>
              </div>
            ))}

            {/* Closing line */}
            <div className="mt-2 p-5 bg-navy rounded-xl">
              <p className="text-white text-sm font-medium leading-relaxed text-center">
                Every part of Imperium is designed to do one thing — help you win more closings.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
